import { isValid } from 'date-fns/fp/isValid'
import { parse } from 'date-fns/parse'

import { pipe } from 'aem-libs-ts/src/utils/common/pipe'

const formats = ['dd.M.yyyy', 'dd.MM.yyyy']

export const parseDateProcess =
  (fallbackDate: Date) =>
  (parsedString: string): Date => {
    return pipe(() => formats)
      .map((formats) => formats.map((dateformat) => parse(parsedString, dateformat, new Date())))
      .map((formats) => formats.find(isValid))
      .throwNullable()
      .getOrElse(() => fallbackDate)
  }
